import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { BorderRadiusThemeProps } from 'shared/common/themes/theme';
import { ResetButton } from 'shared/components/buttons/ResetButton/ResetButton';

import { BorderRadiusPanel } from '../../../../../../components/controlledPanels/BorderRadiusPanel/BorderRadiusPanel';
import { FormControl } from '../../../../../../components/controlledPanels/FormControl/FormControl';
import { DEFAULT_BORDER_RADIUS } from '../../consts';
import type { TooltipConfigProps } from '../TooltipConfig';

export function Corners(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, onUpdateStyle } = props;
  const { t } = useTranslation('components.theme.settings');

  const setCornerRadius = useCallback(
    (newCornerRadius: Partial<BorderRadiusThemeProps>) => {
      onUpdateStyle({ cornerRadius: { ...DEFAULT_BORDER_RADIUS, ...styles.cornerRadius, ...newCornerRadius } });
    },
    [onUpdateStyle, styles.cornerRadius]
  );

  return (
    <FormControl title={t('cornerRadius')}>
      <BorderRadiusPanel
        label={t('cornerRadius')}
        setBorderRadius={setCornerRadius}
        borderRadius={styles.cornerRadius ?? DEFAULT_BORDER_RADIUS}
        resetButton={styles.cornerRadius && <ResetButton onClick={() => onRemoveStyle('cornerRadius')} />}
      />
    </FormControl>
  );
}
